import React, { useContext } from "react";
import { SelectButton } from "primereact/selectbutton";
import { SettingsContext } from "./SettingsContext.tsx";
import { StoryTypeOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * Which stories a word-problem sheet draws (ADR 0073 section 2).
 *
 * Simple is the sheet as it has always been: one story shape per operation, so
 * the story's own wording gives the operation away. Varied adds stories where
 * the unknown is not the result, and comparisons, and deals the operations
 * evenly on every page, so the student has to read the story to choose.
 *
 * Advanced, on ADR 0023 section 2's test: a visitor who wants a word-problem
 * sheet at all does not have to answer it.
 */
export function StoryTypeSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleChange(value: StoryTypeOptions) {
        // SelectButton hands back null when the current option is clicked again; a sheet is
        // always one of the two, so Simple stands in for "no selection".
        setSettings({ ...settings, StoryTypes: value ?? StoryTypeOptions.Simple });
    }

    return (
        <div className="storyTypesContainer">
            <span className="settingLabel">{t('settings.storyTypesLabel')}</span>
            <SelectButton
                value={settings.StoryTypes ?? StoryTypeOptions.Simple}
                onChange={(e) => handleChange(e.value)}
                options={withLabels(Object.values(StoryTypeOptions), settings.Language)}
                className="select"
                aria-label={t('settings.storyTypesAria')}
            />
            <p className="settingNote">{t('settings.storyTypesHint')}</p>
        </div>
    );
}

export default StoryTypeSettings;
